import React from "react";
import { Stack } from '@mui/material';

const name = "OptionalSwitches";

const OptionalSwitches: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    return (
        <Stack direction="row">{children}</Stack>
    );
}

OptionalSwitches.displayName = name;

export default OptionalSwitches;